import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, ButtonProps, DialogDrawerRenderProps } from '@economic/taco';
import { useLocalStorage } from '@economic/react-app';
import { t } from '../../../../../shared/components/l10n/l10n';

interface Props extends Omit<ButtonProps, 'appearance' | 'children' | 'drawer' | 'onClick'> {
    drawer: DialogDrawerRenderProps;
}

export function EmailOptionsDrawerToggle({ drawer, ...buttonProps }: Props) {
    const location = useLocation();
    const [emailOptionsDrawerVisible, setEmailOptionsDrawerVisible] = useLocalStorage<boolean>(
        `${location.pathname}.emailOptionsDrawerVisible`,
        true
    );

    useEffect(() => {
        if (emailOptionsDrawerVisible && !drawer.open) {
            drawer.toggle();
        }
    }, []);

    function toggleDrawer() {
        drawer.toggle();
        setEmailOptionsDrawerVisible(!emailOptionsDrawerVisible);
    }

    return (
        <Button {...buttonProps} appearance="discrete" onClick={toggleDrawer}>
            {drawer.open ? t`FORM_BOOKANDSEND_EMAIL_OPTIONS_CLOSE` : t`FORM_BOOKANDSEND_EMAIL_OPTIONS_OPEN`}
        </Button>
    );
}
